/* Kaia Studio 2026 design. Progressive behaviour for .k2 sections. */
(function(){
  function all(s,r){return [].slice.call((r||document).querySelectorAll(s));}
  function ready(fn){if(document.readyState!=='loading')fn();else document.addEventListener('DOMContentLoaded',fn);}
  ready(function(){
    if(window.__k2)return; window.__k2=true;
    var params=new URLSearchParams(location.search);

    /* mobile slider dots */
    all('.k2 .gallery,.k2 .fgrid').forEach(function(el){
      var d=document.createElement('div'); d.className='dots'; var n=0; if(!el.children.length)return;
      el.after(d);
      function build(){n=[].filter.call(el.children,function(c){return c.style.display!=='none';}).length; d.innerHTML=''; for(var i=0;i<n;i++) d.appendChild(document.createElement('i')); upd();}
      function upd(){if(!n)return; var k=Math.round(el.scrollLeft/(el.scrollWidth/n)); [].forEach.call(d.children,function(c,j){c.classList.toggle('on',j===k);});}
      el.addEventListener('scroll',upd,{passive:true}); el._k2build=build; build();
    });

    /* back to top (keep one) */
    var tts=all('.k2 .totop'); tts.slice(1).forEach(function(t){t.remove();});
    var tt=tts[0];
    if(tt){
      var ttv=function(){tt.classList.toggle('on',window.scrollY>window.innerHeight*0.8);};
      window.addEventListener('scroll',ttv,{passive:true}); ttv();
      tt.addEventListener('click',function(){var rm=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches; window.scrollTo({top:0,behavior:rm?'auto':'smooth'});});
    }

    /* long detail fold */
    var lg=document.getElementById('long'), more=document.getElementById('long-more');
    if(lg&&more) more.addEventListener('click',function(){
      var open=lg.classList.toggle('is-folded')===false;
      more.setAttribute('aria-expanded',open); more.textContent=open?'Show less':'Show full details';
      if(!open) lg.scrollIntoView({block:'start'});
    });

    /* shop all: tabs + sort */
    var grid=document.getElementById('shop-grid');
    if(grid){
      var cards=[].slice.call(grid.children), tabs=all('.k2 .tab'), sortSel=document.getElementById('shop-sort'), cat='all';
      var render=function(){
        var m=sortSel?sortSel.value:'featured';
        cards.slice().sort(function(a,b){var d=m==='low'?a.dataset.price-b.dataset.price:m==='high'?b.dataset.price-a.dataset.price:0; return d||a.dataset.order-b.dataset.order;}).forEach(function(c){c.hidden=!(cat==='all'||c.dataset.cat===cat); grid.appendChild(c);});
      };
      tabs.forEach(function(t){
        if(t.dataset.cat!=='all'&&!cards.some(function(c){return c.dataset.cat===t.dataset.cat;})) t.hidden=true;
        t.addEventListener('click',function(){cat=t.dataset.cat; tabs.forEach(function(x){x.setAttribute('aria-pressed',x===t);}); render();});
      });
      if(sortSel) sortSel.addEventListener('change',render);
    }

    /* product: swatches, variants, gallery order */
    var vEl=document.getElementById('k2-variants'), variants=[];
    try{ if(vEl) variants=JSON.parse(vEl.textContent); }catch(e){}
    var sw=all('.k2 .swatch'), names=all('.k2 .color-name'), gal=document.getElementById('k2-gallery');
    var figs=gal?[].slice.call(gal.children):[]; figs.forEach(function(f,i){f.dataset.i=i;});
    function pick(name,push,keep){
      var key=String(name).toLowerCase(), chosen=null;
      sw.forEach(function(b){var on=b.dataset.name.toLowerCase()===key; b.setAttribute('aria-pressed',on); if(on){chosen=b; names.forEach(function(n){n.textContent=b.dataset.name;});}});
      if(!chosen) return;
      var v=variants.filter(function(x){return String(x.id)===chosen.dataset.variant;})[0];
      if(v){
        all('.k2 .js-variant').forEach(function(i){i.value=v.id;});
        all('.k2 .js-price').forEach(function(p){p.textContent=v.price;});
        all('.k2 .js-compare').forEach(function(p){p.textContent=v.compare||''; p.hidden=!v.compare;});
        all('.k2 .js-cart .add').forEach(function(b){b.disabled=!v.available; b.textContent=v.available?(b.dataset.label||'Add to Bag'):'Sold out';});
        if(push&&history.replaceState){var u=new URL(location.href); u.searchParams.set('variant',v.id); history.replaceState({}, '', u);}
      }
      if(gal&&figs.length&&!keep){
        var starts=variants.map(function(x){return x.pos;}).filter(function(p){return p>0;}).sort(function(a,b){return a-b;});
        var pos=+chosen.dataset.pos||0, next=starts.filter(function(p){return p>pos;})[0]||Infinity;
        var mine=function(f){ if(f.dataset.c) return f.dataset.c===key; if(pos>0) return (+f.dataset.pos>=pos&&+f.dataset.pos<next); return false; };
        var rank=function(f){return mine(f)?(f.dataset.s?0:1):2;};
        figs.slice().sort(function(a,b){return rank(a)-rank(b)||a.dataset.i-b.dataset.i;}).forEach(function(f){f.style.display=(f.dataset.s&&f.dataset.c!==key)?'none':''; gal.appendChild(f);});
        if(gal._k2build) gal._k2build();
        gal.scrollLeft=0;
      }
    }
    sw.forEach(function(b){b.addEventListener('click',function(){pick(b.dataset.name,true);});});
    if(params.get('color')) pick(params.get('color'),false,true);
    else { var pre=sw.filter(function(b){return b.getAttribute('aria-pressed')==='true';})[0]; if(pre&&params.get('variant')) pick(pre.dataset.name,false,true); }

    /* waitlist + registry + add to bag */
    var buys=all('.k2 .buy');
    function joined(){buys.forEach(function(w){var nb=w.querySelector('.js-notify'), nf=w.querySelector('.js-form'), fine=w.querySelector('.js-fine'); if(!nb)return; if(nf)nf.hidden=true; nb.hidden=false; nb.textContent="You're on the list"; nb.disabled=true; if(fine) fine.textContent="We'll email your 20% code on launch day.";});}
    buys.forEach(function(w){
      var nb=w.querySelector('.js-notify'), nf=w.querySelector('.js-form'), reg=w.querySelector('.js-reg'), cart=w.querySelector('.js-cart');
      if(nb&&nf) nb.addEventListener('click',function(){nb.hidden=true; nf.hidden=false; var i=nf.querySelector('input[type=email]'); if(i)i.focus();});
      if(reg) reg.addEventListener('click',function(){
        if(typeof bl!=='undefined'&&bl.addToRegistry){ bl.addToRegistry({images:reg.dataset.babylistImage,price:reg.dataset.babylistPrice,title:reg.dataset.babylistTitle,url:reg.dataset.babylistUrl}); }
      });
      if(cart) cart.addEventListener('submit',function(e){
        e.preventDefault();
        var btn=cart.querySelector('.add'), id=cart.querySelector('.js-variant').value, label=btn.textContent;
        btn.disabled=true; btn.textContent='Adding…';
        var hdr=document.querySelector('[id^="shopify-section-sections--"][id$="__header_section"]');
        var sid=hdr?hdr.id.replace('shopify-section-',''):null;
        var body={id:parseInt(id,10),quantity:1}; [].forEach.call(cart.querySelectorAll('input[name^="properties["]'),function(p){body.properties=body.properties||{}; body.properties[p.name.slice(11,-1)]=p.value;}); if(sid){body.sections=sid; body.sections_url=location.pathname;}
        fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root?Shopify.routes.root:'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)})
        .then(function(r){return r.json();})
        .then(function(data){
          if(data&&data.status&&data.status>=400) throw new Error(data.description||'cart');
          if(sid&&data.sections&&data.sections[sid]){
            var doc=new DOMParser().parseFromString(data.sections[sid],'text/html');
            ['cart-items-component','cart-icon'].forEach(function(t){var n=doc.querySelector(t), c=document.querySelector(t); if(n&&c) c.innerHTML=n.innerHTML;});
          }
          var drawer=document.querySelector('cart-drawer-component');
          if(drawer&&typeof drawer.open==='function') drawer.open(); else if(!sid) location.href=(window.Shopify&&Shopify.routes&&Shopify.routes.root?Shopify.routes.root:'/')+'cart';
          btn.textContent='Added to Bag'; btn.disabled=false; setTimeout(function(){btn.textContent=label;},2000);
        })
        .catch(function(){ cart.submit(); });
      });
    });
    if(params.get('customer_posted')==='true') joined();
    if(/[?&]form_type=customer/.test(location.search)||document.querySelector('.k2 .js-form .errors')){ buys.forEach(function(w){var nb=w.querySelector('.js-notify'), nf=w.querySelector('.js-form'); if(nb&&nf&&nf.querySelector('.errors')){nb.hidden=true; nf.hidden=false;}}); }
  });
})();
